module.exports = "/images/vendor/flag-icon-css/flags/4x3/ht.svg?fb289ca05aec82435254286e5410df58";